// extracted by mini-css-extract-plugin
module.exports = {"formInput":"SyncCard_formInput__1KBTM"};